module.exports = __webpack_public_path__ + "img/hill.c15abcdf.png";